export const home = "/paraempresa/";

export const seguroEmpresarial =
  "/paraempresa/seguro-facil-empresarial-empreendedor";

export const seguroMultirrisco = "/paraempresa/seguro-multirisco-empresarial";
export const seguroLoterico = "/paraempresa/seguro-empresarial-loterico-e-cca";
export const seguroSaude = "/paraempresa/seguro-saude-empresarial";
